export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/hint.8a82a19a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};